import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-empty"} maskId="square-filled-radius-0-stroke-1-IconPageEmpty"><path d="M20 2H4V22H20V2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageEmpty;
